<template>
    <div>
        <img name="imageshow" class="fl f-logo" v-if="show_img" v-show="formData.cid_img_lnk||this.original_url" :src="this.formData.cid_img_lnk||this.original_url" style="margin-right: 5px">
        <Upload :before-upload="upImg" action="/" :format="['jpg','jpeg','png']" max-size="1024">
            <Button type="primary">{{$t('choosePic')}}</Button>
        </Upload>
    </div>
</template>

<script>
    import lrz from 'lrz'
    import moment from "moment";
    // import {client} from "../utils/configOss";
    let OSS = require('ali-oss');
    export default {
        name: "myUploadCompressedPic",
        props:{
            original_url: {
                default: '',
                type: String
            },
            lrz_flag:{
                default: true,
                type: Boolean
            },
            show_img:{
                default: true,
                type: Boolean
            },
            data_index:{ //如果是数组反出数组的Index
                default: -1,
                type: Number
            },
            // 文件上传目录
            // org/info 组织形象照目录
            // org/build 组织建筑目录
            // org/cid 组织营业执照目录
            // goods/info 商品形象照
            path: {
                default: `other/${moment().format("YYYY-MM-DD")}/${moment().format("HHmmssSSSSSSSSS")}`
            }
        },
        data:function(){
            return{
                formData : {cid_img_lnk:''},
                compressed_pic_address : ''
            }
        },
        mounted: function () {
            this.formData.cid_img_lnk = this.original_url;
        },
        methods: {
            upImg: function (file) {
                var _this = this;

                // 文件直接上传到阿里云oss
                let fileNameArr = file.name.split('.')
                let fileNameLast = fileNameArr[fileNameArr.length - 1]
                let fileNameStr = file.name.substring(0, file.name.length - fileNameLast.length - 1) + moment().format("HHmmssSSS") + Math.ceil(Math.random() * 12345)
                // 暂时只用other文件夹
                // var fileName = `${_this.path}/${fileNameStr}.${fileNameLast}`
                let fileName = `other/${moment().format("YYYY-MM-DD")}/${fileNameStr}.${fileNameLast}`

                if(this.lrz_flag){
                    let option = {
                        width : 300,
                        height: 'auto',
                        quality: 0.5
                    };
                    lrz(file, option).then(function(rst) {
                        _this.formData.cid_img_lnk = rst.base64;
                        let data = {};
                        data.file = rst.base64;

                        var fileObj = _this.$base.base64ToFile(data.file, `${fileNameStr}.${fileNameLast}`)

                        _this.$base.showLoading();
                        _this.$request.sendPost('com/get-upimg-key', {}, (success, data2, error) => {
                            if(success){
                                var client = new OSS({
                                    region: data2.region, //地域
                                    accessKeyId: data2.accessKeyId, //你自己的key和id
                                    accessKeySecret: data2.accessKeySecret,
                                    bucket: data2.bucket, //oss上你的存储空间名称
                                    secure: true,
                                })
                                client.multipartUpload(fileName, fileObj).then(res => {
                                    _this.$base.hideLoading();
                                    let url = res.res.requestUrls[0]
                                    if(url.indexOf("?") != -1){
                                        url = url.split("?")[0];
                                        console.log(url);
                                    }
                                    _this.$emit('getCompressImgAddr',url);
                                }).catch(err => {
                                    _this.$base.msgErr(_this.$t('upload_err'));
                                })
                            }
                            else {
                                _this.$base.alertErr(error.errmsg);
                            }
                        })
                    })
                    .catch(function(error) {
                        _this.$base.alertErr(error.errmsg);
                    })
                }
                else{
                    let data = {};
                    var reader = new FileReader();
                    reader.readAsDataURL(file);
                    reader.onload = function (e) {
                        _this.formData.cid_img_lnk = e.target.result;
                        data.file = _this.formData.cid_img_lnk;

                        var fileObj = _this.$base.base64ToFile(data.file, `${fileNameStr}.${fileNameLast}`)

                        _this.$base.showLoading();
                        _this.$request.sendPost('com/get-upimg-key', {}, (success, data2, error) => {
                            if(success){
                                var client = new OSS({
                                    region: data2.region, //地域
                                    accessKeyId: data2.accessKeyId, //你自己的key和id
                                    accessKeySecret: data2.accessKeySecret,
                                    bucket: data2.bucket, //oss上你的存储空间名称
                                    secure: true,
                                })
                                client.multipartUpload(fileName, fileObj).then(res => {
                                    _this.$base.hideLoading();
                                    let url = res.res.requestUrls[0]
                                    if(url.indexOf("?") != -1){
                                        url = url.split("?")[0];
                                        console.log(url);
                                    }
                                    _this.$emit('getCompressImgAddr',url);
                                    _this.$emit('onChange',{data_index:_this.data_index,file_path:url});
                                }).catch(err => {
                                    _this.$base.msgErr(_this.$t('upload_err'));
                                })
                            }
                            else {
                                _this.$base.alertErr(error.errmsg);
                            }
                        })
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .f-logo{
        width: 200px;
        height: auto;
        border: 1px solid #dcdee2;
        border-radius: unset;
    }
</style>



// WEBPACK FOOTER //
// src/components/myUploadCompressedPic.vue